import week0 from './week0.jpeg';
import week1 from './week1.jpeg';
import week2 from './week2.jpeg';
import demoday from './assets/v58I9w8.jpg';

import './App.css';

import React from 'react';


function App() {

  return (
    <div className="App">
      <main className="grid-area">

        <section className="header">
          
          <h1 className="title">
            Natura
          </h1>
          
        </section>

        <section className="demo">
      

          <h2>What is Natura?</h2>
          <h3>Natura is a turn-based tactical RPG inspired by classics like Final Fantasy Tactics and XCOM.</h3>
          <h3>Command a squad of Peacekeepers and Technicians in their mission to the war-torn Lumo Region, the birthplace of a mysterious technology.</h3>
          <h3>Follow us on itch.io to keep up with our progress, and to play the first chapter of Natura (release aiming for Q2 of 2023).</h3>

          
            <a href="https://ice-wizardry.itch.io" target="_blank">Follow Us!</a>

        </section>

        <section className="choices">
     
        <ul>

        <li>
              <figure>
                <img src={week1} alt="AI generated landscape" />
              </figure>

              <div className="item-info">
                <p>
                  Natura Tactical RPG            
                </p>
              <a href="/gameinfo">Game Overview</a>
              </div>
            </li>

          <li>
              <figure>
                <img src={week2} alt="AI generated landscape" />
                
              </figure>
              <div className="item-info">
                <p>
                  Nights & Weekends Progress             
                </p>
              <a href="/devposts">Devblog Posts</a>
              </div>
            </li>

        </ul>
        </section>

        

      </main>

      <footer>
        <h3>art on this page was generated using <a href="https://lexica.art" target="blank">{ }Lexica{ }</a>.</h3>
        <h4>updated 29 January 2023</h4>
      </footer>

    </div>
  );
}

export default App;
